import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { isRTL } from '../config';
import { PureComponent } from '../component';
import { range } from '../utils/numbers';
import { defaultProps } from '../utils/defaultProps';
import { rateClass } from './styles';
import getDataset from '../utils/dom/getDataset';
var MIN_SIZE = 12;

var DefaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  repeat: true,
  max: 5,
  size: 20,
  text: [],
  value: 0
});

var Rate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Rate, _PureComponent);

  var _super = _createSuper2(Rate);

  function Rate(props) {
    var _this;

    _classCallCheck(this, Rate);

    _this = _super.call(this, props);
    _this.highlightTimer = void 0;
    _this.state = {
      hover: 0,
      highlight: -1
    };
    return _this;
  }

  _createClass(Rate, [{
    key: "getValue",
    value: function getValue() {
      var hover = this.state.hover;
      return Number(hover === 0 ? this.props.value : hover);
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var size = this.props.size;
      if (!size) return undefined;
      var parsed = Math.max(MIN_SIZE, parseFloat("".concat(size)));
      return {
        width: parsed,
        fontSize: parsed,
        position: 'relative'
      };
    }
  }, {
    key: "getScale",
    value: function getScale() {
      var _this$props$size = this.props.size,
          size = _this$props$size === void 0 ? DefaultProps.size : _this$props$size;
      if (size >= MIN_SIZE) return undefined;
      return {
        transform: "scale(".concat(Number(size) / MIN_SIZE, ")")
      };
    }
  }, {
    key: "getIcon",
    value: function getIcon(icons, i, isBg) {
      var _this$props = this.props,
          repeat = _this$props.repeat,
          allowHalf = _this$props.allowHalf;
      var value = this.getValue();
      var remain = value - i;
      var icon;

      if (!Array.isArray(icons)) {
        icon = icons;
      } else {
        icon = icons[repeat ? value - 1 : i];
        if (!icon) icon = icons[icons.length - 1];
      }

      if (remain <= 0 || remain >= 1 || isBg) return icon;
      var style = {
        width: "".concat(remain * 100, "%"),
        display: 'block',
        overflow: 'hidden',
        fontSize: 'inherit'
      };
      return (
        /*#__PURE__*/
        React.createElement("span", {
          style: style,
          className: allowHalf ? rateClass('allow-half') : undefined
        }, icon)
      );
    }
  }, {
    key: "handleClick",
    value: function handleClick(value, e) {
      var _this2 = this;

      var _this$props2 = this.props,
          clearable = _this$props2.clearable,
          allowHalf = _this$props2.allowHalf;

      if (allowHalf && e.target.parentElement.querySelector(".".concat(rateClass('allow-half')))) {
        value -= 0.5;
      }

      if (clearable && this.props.value === value) {
        value = 0;
        this.setState({
          hover: 0
        });
      }

      this.props.onChange(value);
      this.setState({
        highlight: value
      });
      if (this.highlightTimer) clearTimeout(this.highlightTimer);
      this.highlightTimer = setTimeout(function () {
        _this2.setState({
          highlight: -1
        });
      }, 300);
    }
  }, {
    key: "handleHover",
    value: function handleHover(hover) {
      this.setState({
        hover: hover
      });
    }
  }, {
    key: "handleMove",
    value: function handleMove(hover, e) {
      var _getBoundingClientRec = e.target.getBoundingClientRect(),
          x = _getBoundingClientRec.x,
          width = _getBoundingClientRec.width;

      var offset;

      if (isRTL()) {
        offset = x + width / 2 < e.clientX ? 0.5 : 0;
      } else {
        offset = x + width / 2 > e.clientX ? 0.5 : 0;
      }

      this.setState({
        hover: hover - offset
      });
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this3 = this;

      var _this$props3 = this.props,
          background = _this$props3.background,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? DefaultProps.max : _this$props3$max,
          disabled = _this$props3.disabled;
      var style = this.getStyle();
      var value = this.getValue();
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: rateClass('background')
        }, range(max).map(function (v) {
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: v // the allowHalf only for the front same as background
              ,
              style: Object.assign({
                visibility: !disabled && Math.floor(value) > v ? 'hidden' : 'visible'
              }, style)
            }, _this3.getIcon(background, v, true))
          );
        }))
      );
    }
  }, {
    key: "renderRate",
    value: function renderRate() {
      var _this4 = this;

      var _this$props4 = this.props,
          front = _this$props4.front,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? DefaultProps.max : _this$props4$max,
          _this$props4$text = _this$props4.text,
          text = _this$props4$text === void 0 ? DefaultProps.text : _this$props4$text,
          allowHalf = _this$props4.allowHalf;
      var highlight = this.state.highlight;
      var value = this.getValue();
      var style = this.getStyle();
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: rateClass('front')
        }, range(max).map(function (v) {
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: v,
              onClick: _this4.handleClick.bind(_this4, v + 1),
              onMouseMove: allowHalf ? _this4.handleMove.bind(_this4, v + 1) : undefined,
              onMouseEnter: !allowHalf ? _this4.handleHover.bind(_this4, v + 1) : undefined,
              style: style
            },
            /*#__PURE__*/
            React.createElement("div", {
              style: {
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              onMouseLeave: _this4.handleHover.bind(_this4, 0)
            }), value > v ? _this4.getIcon(front, v) :
            /*#__PURE__*/
            React.createElement("span", null, "\xA0"), highlight === v + 1 &&
            /*#__PURE__*/
            React.createElement("i", {
              className: rateClass('highlight')
            }, _this4.getIcon(front, v)))
          );
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: rateClass('text')
        }, text[Math.ceil(value) - 1]))
      );
    }
  }, {
    key: "renderStatic",
    value: function renderStatic() {
      var _this5 = this;

      var _this$props5 = this.props,
          front = _this$props5.front,
          _this$props5$value = _this$props5.value,
          value = _this$props5$value === void 0 ? DefaultProps.value : _this$props5$value,
          _this$props5$max = _this$props5.max,
          max = _this$props5$max === void 0 ? DefaultProps.max : _this$props5$max,
          _this$props5$text = _this$props5.text,
          text = _this$props5$text === void 0 ? DefaultProps.text : _this$props5$text;
      var style = this.getStyle();
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: rateClass('static')
        }, range(max).map(function (v) {
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: v,
              style: style
            }, value > v && _this5.getIcon(front, v))
          );
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: rateClass('text')
        }, text[Math.ceil(value) - 1]))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var className = classnames(rateClass('_', isRTL() && 'rtl'), this.props.className);
      var ms = Object.assign({}, this.props.style, this.getScale());
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: ms
        }, getDataset(this.props)), this.renderBackground(), this.props.disabled ? this.renderStatic() : this.renderRate())
      );
    }
  }]);

  return Rate;
}(PureComponent);

Rate.defaultProps = DefaultProps;
export default Rate;